import React, { useState } from 'react';
import { subscriberService } from '../../../services/firebase/subscriberService';
import Button from '../Button';
import './Newsletter.css';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      const result = await subscriberService.subscribe(name, email);
      if (result.success) {
        setIsSubmitted(true);
        setName('');
        setEmail('');
        setTimeout(() => setIsSubmitted(false), 8000);
      } else {
        setError('Something went wrong. Please try again.');
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="newsletter">
      <div className="container">
        <div className="newsletter__content">
          <div className="newsletter__text">
            <h2>Join Our Community</h2>
            <p>
              Subscribe to receive holistic wellness tips, meditation guides,
              and updates on upcoming events. Plus, get a free guided meditation
              when you sign up!
            </p>
          </div>

          <form className="newsletter__form" onSubmit={handleSubmit}>
            <div className="newsletter__inputs">
              <input
                type="text"
                placeholder="Your Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className="newsletter__input"
              />
              <input
                type="email"
                placeholder="Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="newsletter__input"
              />
              <Button type="submit" variant="accent" size="large" disabled={isSubmitting}>
                {isSubmitting ? 'Subscribing...' : 'Get Free Meditation'}
              </Button>
            </div>
            {isSubmitted && (
              <p className="newsletter__success">
                Thank you for subscribing! Check your email for your free meditation.
              </p>
            )}
            {error && (
              <p className="newsletter__error" style={{ color: '#e74c3c', marginTop: '0.5rem' }}>
                {error}
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
